// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"229":"e3d66013","561":"576cbf6c","571":"491d0103"}[chunkId] + ".css";
};